import MainAccordion from "../Accordion/MainAccordion";
import TrialEConsent from "../Trials/TrialEConsent";

const EConsentAccordion = ({
  trialDetails,
  setTrialDetails,
  hasBasicInfoChanged,
  setHasBasicInfoChanged,
  handleBasicInfoUpdate,
}) => {
  return (
    <MainAccordion
      title="E-Consent"
      data={
        <TrialEConsent
          trialDetails={trialDetails}
          setTrialDetails={setTrialDetails}
          hasBasicInfoChanged={hasBasicInfoChanged}
          setHasBasicInfoChanged={setHasBasicInfoChanged}
          handleBasicInfoUpdate={handleBasicInfoUpdate}
        />
      }
    />
  );
};
export default EConsentAccordion;
